import { report_stop_bus_timeService } from '../_services';

const state = { onRequest: false, report_stop_bus_time: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_stop_bus_timeService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_stop_bus_time: state => {
    return state.report_stop_bus_time
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_stop_bus_time = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_stop_bus_time = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_stop_bus_time = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_stop_bus_times = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
